import React from 'react';

import * as S from './styles';

function FieldDefault({ value = '', label, ...rest }) {
    return (
        <S.Container {...rest}>
            <S.Label>{label}</S.Label>
            <S.InputContainer>{value}</S.InputContainer>
        </S.Container>
    );
}
export default FieldDefault;
